module.exports = __webpack_public_path__ + "img/saman.80054858.png";